import { default as i18next } from "i18next";
import { initReactI18next } from "react-i18next";

import translationFr from "./fr.json";
// import translationEn from "./en.json";
// import translationHi from "./hi.json";

export const initTranslation = (locale = "fr") => {
    i18next.use(initReactI18next).init({
        resources: {
            fr: {
                translation: translationFr,
            },
            /*
            en: {
                translation: translationEn,
            },
            hi: {
                translation: translationHi,
            },
            */
        },
        lng: locale,
        fallbackLng: "fr",
        keySeparator: ":", // means no nested json keys
        nsSeparator: "::", // avoid use of namespace (default :), otherwise it will break key after :
        interpolation: {
            escapeValue: true,
        },
        react: {
            useSuspense: true, // Enable Suspense mode
        },
    });
};
